import { gql } from "@apollo/client";

export const SystemAssetListTotal = gql`
    query SystemAssetListTotal($id: ID!) {
        system(id: $id) {
            id
            assetList {
                total
            }
            systemLimits {
                maxAssets
                maxPressureLines
            }
        }
    }
`;
